var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28047 18.5163C14.317 18.4713 18.3638 14.3081 18.3193 9.21743C18.2748 4.12679 14.1559 0.0364596 9.11938 0.0814218C4.0829 0.126384 0.0360795 4.28961 0.0805634 9.38025C0.125047 14.4709 4.24399 18.5612 9.28047 18.5163Z",
    fill: "#ff6633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6731 5.20075C14.0517 5.51365 14.11 6.08038 13.8032 6.46659L8.08428 13.6666C7.92601 13.8658 7.69193 13.9867 7.4408 13.999C7.18968 14.0112 6.94536 13.9136 6.76919 13.7306L4.25286 11.1173C3.9114 10.7627 3.91643 10.1929 4.2641 9.84459C4.61177 9.4963 5.17042 9.50143 5.51188 9.85605L7.33547 11.7499L12.4321 5.33348C12.7388 4.94727 13.2945 4.88784 13.6731 5.20075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMediaIcon);
export default __webpack_public_path__ + "static/media/selected-media-icon.ea3a170d74fc83f5fcf75cefdd3d4068.svg";
export { ForwardRef as ReactComponent };